import { baseApi } from '@shared/api/baseApi.js';

export const addCompanyAdmin = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		addCompanyAdmin: builder.mutation({
			query: ({ companyId, redirectURL, ...body }) => ({
				url: `/v2/companies/${companyId}/companyUsers`,
				method: 'POST',
				headers: { redirectURL },
				body,
			}),
			invalidatesTags: (_result, error, { companyId, employeeId }) =>
				error
					? []
					: [
							{ type: 'CompanyAdmins', id: companyId },
							...(employeeId ? [{ type: 'Employee', id: employeeId }] : []),
						],
		}),
	}),
});

export const { useAddCompanyAdminMutation } = addCompanyAdmin;

// POST /v2/companies/{companyId}/companyUsers
// Add new CompanyUser with rights to manage the company with user data or employeeId.
//
// Headers:
//   redirectURL — URL to redirect the user to after completing consent (used with 300 flow).
//                 Pass window.location.href so the popup returns to the current page after consent.
//
// Body:
//   firstName   string
//   lastName    string
//   email       string (email format)
//   phone       string
//   birthDate   string (date, RFC 3339 full-date, e.g. "2017-07-21")
//   employeeId  string (uuid) — alternative to user data fields
//
// Responses:
//   200 { id: string (uuid) }  — admin created successfully, no consent needed
//   300 { loginURL: string }   — additional authentication required; open loginURL in a popup,
//                                after consent the popup redirects to redirectURL
//   400  Bad request
//   401  Unauthorized
//   404  Not found
//   409  Conflict — CompanyUser already exists (error.data.message: "CompanyUser already exists")
